export interface BookingPriceVisibilityInput {
  configuredToShowPrices: boolean;
  isInternalBooking: boolean;
  enabledPayments: boolean;
  requirePaymentForBooking: boolean;
  canTakeCard: boolean;
}

/**
 * A tenant may hide prices for free/in-person booking. Amounts must remain
 * visible whenever this flow can charge a card, even if the presentation flag
 * was turned off accidentally.
 */
export const shouldDisplayBookingPrices = ({
  configuredToShowPrices,
  isInternalBooking,
  enabledPayments,
  requirePaymentForBooking,
  canTakeCard,
}: BookingPriceVisibilityInput): boolean =>
  configuredToShowPrices ||
  isInternalBooking ||
  requirePaymentForBooking ||
  (enabledPayments && canTakeCard);
